import React from 'react';

import { formatMoney } from '@betterment/core';
import { Box, Text, Tooltip } from '@betterment/samba-react';
import { HR } from '@betterment/style-closet-react';

import { EmployerFourOhOneKContributionsAllTime } from '../../data';
import ReffableIcon from '../ReffableIcon';

interface Props {
  employerFourOhOneKContributionsAllTime: EmployerFourOhOneKContributionsAllTime;
}

const AllTimeContributions: React.FC<React.PropsWithChildren<Props>> = ({ employerFourOhOneKContributionsAllTime }) => {
  return (
    <Box css={{ mt: 'space.200' }}>
      <>
        <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Box>
            <Text>Total employer contributions</Text>
            <Tooltip>
              <Tooltip.Trigger asChild={true}>
                <ReffableIcon name="InfoCircle" size="small" css={{ verticalAlign: 'middle' }} />
              </Tooltip.Trigger>
              <Tooltip.Content side="bottom">
                Your total employer contribution amount includes market changes and represents the current balance
                attributed to employer match.
              </Tooltip.Content>
            </Tooltip>
          </Box>
          <Text>{formatMoney(employerFourOhOneKContributionsAllTime.balance)}</Text>
        </Box>
        {employerFourOhOneKContributionsAllTime.vested && (
          <>
            <HR my="6" />
            <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box css={{ display: 'flex', alignItems: 'center' }}>
                <Text color="text.weak">Vested balance</Text>
                <Tooltip>
                  <Tooltip.Trigger asChild={true}>
                    <ReffableIcon color="icon.weak" name="InfoCircle" size="xsmall" css={{ verticalAlign: 'middle' }} />
                  </Tooltip.Trigger>
                  <Tooltip.Content side="bottom">
                    Based on criteria set by your employer for when you gain full rights to employer matching
                    contributions.
                  </Tooltip.Content>
                </Tooltip>
              </Box>
              <Box css={{ display: 'flex', flexDirection: 'column' }}>
                <Text css={{ textAlign: 'right' }} color="text.weak" variant="text50">
                  {formatMoney(employerFourOhOneKContributionsAllTime.vested.amount)}
                </Text>
                <Text css={{ textAlign: 'right' }} color="text.success" variant="text50">
                  {employerFourOhOneKContributionsAllTime.vested.percent}% vested
                </Text>
              </Box>
            </Box>
          </>
        )}
      </>
    </Box>
  );
};

export default AllTimeContributions;
